import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Nav from '../Header/Nav'
import AddressPage from './AddressPage'
import WhatssapIcon from '../Home/WhatssapIcon'


const Adresse = () => {
    return (
        <div>

            <Header />

            <Nav target="adresse" />

            <AddressPage />

            <WhatssapIcon />

            <Footer />


        </div>
    )
}

export default Adresse